
import React, { useState , useCallback  , useEffect  , useReducer }  from 'react';
import { useTranslation } from 'react-i18next';
import Button from "@material-ui/core/Button";
import { PageHeading } from "../../../../../SharedComponents";
import { Spinner } from '../../../../../Components' ; 
import { showError  , showSuccess , bottomBoxComponentUpdate } from '../../../../../Helper' ; 
import { GetAllPropertyRatingTowerUnitScoresAPI , UpdatePropertyRatingTowerUnitScoresAPI } from '../../../../../Services' ; 
import { TowerUnitsFinishingContant } from './TowerUnitsFinishingContent' ; 

  export const TowerUnitsFinishingView = ({parentTranslationPath , translationPath  , ratingPercentage} ) => { 
    const { t } = useTranslation(parentTranslationPath);

    const[isLoading ,setIsLoading] = useState(false);
    const[selectedList  ,setSelectedList] = useState({
      unitTypes : [] , 
      UnitsFinishing : [] , 
      UnitsFacilities : [] , 
      unitsAmenities : []
    });

    const [towerUnitsFinishingRatingPercentage ,setTowerUnitsFinishingRatingPercentage]  = useState( 0) ;
    const reducer = (state, action) => {
        if (action.id !== 'edit') return { ...state, [action.id]: action.value };
        if (action.id === 'edit') {
          return {
            ...action.value,
          };
        }
        return undefined;
      };

     const [state, setState] = useReducer(reducer, 
    {
        updatePropertyRatingLookupInfoDtos : [] , 
        updatePropertyRatingUnitLayouts : []
     });

    const GetAllPropertyRatingTowerUnitScores = useCallback(async () => 
    {
        setIsLoading(true);
        const res = await GetAllPropertyRatingTowerUnitScoresAPI();
        if (!((res && res.data && res.data.ErrorId) || !res)) 
            setState({ id: 'edit', value:(res) });
         else setState({ id: 'edit', 
          value:{
          updatePropertyRatingLookupInfoDtos : [] , 
          updatePropertyRatingUnitLayouts : [] 
        } });
         setIsLoading(false);
    });

  const onChangeSelectedItem = (value ,index , updatedList ,keyList) => 
      {
          const newSelectedArray = [...updatedList] ;
          newSelectedArray[index].score = value ; 
          setSelectedList((item)=> ({...item , [keyList] : [...newSelectedArray]}));
     
      };

    const reloadData = () => 
    {
        GetAllPropertyRatingTowerUnitScores(); 
    };

    const getNewUpdetedState = () => 
    {
      const newListUpdated = [...selectedList.unitTypes , ...selectedList.UnitsFinishing ,...selectedList.UnitsFacilities , ...selectedList.unitsAmenities ] ;
      return { updatePropertyRatingUnitLayouts :state.updatePropertyRatingUnitLayouts , updatePropertyRatingLookupInfoDtos :newListUpdated }   
    };

    const saveHandler = async () => {
      setIsLoading(true);
      const body = getNewUpdetedState() ; 
      const res = await UpdatePropertyRatingTowerUnitScoresAPI(body); 
      if (!((res && res.status && res.status !== 200) || !res)) {
        showSuccess(t(`${translationPath}tower-unit-scores-updated-successfully`));
          reloadData();
      }
      else  showError(t(`${translationPath}tower-unit-scores-updated-failed`));
      setIsLoading(false) ;
  };

    useEffect(() => {
      reloadData();
      if(ratingPercentage)
        {
          const rating = ratingPercentage.find((f) => f.propertyRatingTabName === "Tower unit & finishing");
          setTowerUnitsFinishingRatingPercentage((rating && rating.score) || 0 ) ; 
        }
    }, [ratingPercentage]);
    
    useEffect( () => {
      bottomBoxComponentUpdate(null);
    },
    []
  );

    return (
      <div className="w-100 mt-4">
        <Spinner isActive={isLoading} isAbsolute />
        <div className="d-flex-v-center-h-between">
          <PageHeading
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            headerTitle={"tower-units-finishing"}
            wrapperClasses={"px-4 pt-2 w-75"}
            headerTitleClasses={"fz-30"}
            subTitleClasses={"fz-12 m-0"}
            subTitle={''}
            titleWithPercentage={`${towerUnitsFinishingRatingPercentage}%`}
          />
          
          <div className="w-25 px-4 d-flex-center fj-end">
          <Button
              className="btns theme-propx outlined"
              id="btn-cancel"
              onClick={() => {
               reloadData()
              }}
            >
              {t(`${translationPath}cancel`)}
            </Button>
            <Button
              className="btns theme-propx solid"
              id="btn-save"
               onClick={() => saveHandler()}
            >
              {t(`${translationPath}save-changes`)}
            </Button>
           
          </div>
         </div>
        <div className="property-rating-container">
          <div className='tower-units-finishing-view mt-2'>
            <TowerUnitsFinishingContant
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                state={state}  
                setState={setState}
                setSelectedList={setSelectedList}
                selectedList={selectedList}
                onChangeSelectedItem={onChangeSelectedItem}
              /> 
             <hr className='hr-line' />
          </div>   
        </div>
      </div>
    );
  } ; 
  